/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { colors } from "../../../components/colors";
import { StyledText } from "../../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FormRow } from "../../common/hook-form";
import * as Inputs from "../../common/hook-form";
import { useFormContext } from "react-hook-form";
import { PrimaryButton } from "../../../components/Buttons";
import {
  DeliveryRuleForm,
  Rule,
} from "../../../service/api-response/DeliveryRule";
import { SelectProductInput } from "../../../components/forms/inputs/SelectProductInput";

const deliveryWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${colors.ctaInactive};
`;

const headerStyle = css`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
`;

const buttonStyle = css`
  right: 0px;
  top: 0px;
  padding-bottom: 4px;
  padding-top: 4px;
  padding-left: 6px;
  padding-right: 6px;
`;
const paragraphStyle = css`
  display: flex;
  flex-direction: row;
  align-item: center;
  gap: 4px;
`;

const bodyWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

type Props = {
  index: number;
  remove: (index: number) => void;
};

export const DeliveryRuleWrapper = ({ index, remove }: Props) => {
  const {
    register,
    formState: { errors: formErrors },
    getValues,
  } = useFormContext<DeliveryRuleForm>();

  return (
    <div css={deliveryWrapperStyle}>
      <div css={bodyWrapper}>
        <div css={headerStyle}>
          <div css={paragraphStyle}>
            <StyledText
              color={colors.ctaMain}
              className="bodyTextSemibold mb-0"
            >
              <FontAwesomeIcon icon={solid("section")} />
            </StyledText>
            <StyledText
              color={colors.ctaMain}
              className="bodyTextSemibold mb-0"
            >
              {index + 1}
            </StyledText>
          </div>
          <PrimaryButton
            color={colors.errorMedium}
            backgroundColor={colors.white}
            hoverColor={colors.errorLight}
            type="button"
            onClick={() => remove(index)}
            height="fit-content"
            css={buttonStyle}
          >
            Remove
          </PrimaryButton>
        </div>
        <FormRow>
          <Inputs.InputFormField
            errorMessage={
              formErrors.rules &&
              formErrors.rules[index]?.minimumDistance?.message
            }
            register={register}
            label="Minimum delivery distance (m)"
            name={`rules.${index}.minimumDistance`}
            type="text"
          />
          <Inputs.InputFormField
            errorMessage={
              formErrors.rules &&
              formErrors.rules[index]?.maximumDistance?.message
            }
            register={register}
            label="Maximum delivery distance (m)"
            name={`rules.${index}.maximumDistance`}
            type="text"
          />
          <SelectProductInput
            name={`rules.${index}.productId`}
            classification="delivery"
            label="Delivery product"
            filterProductsFunction={(products) => {
              const selectedProductId = getValues(
                `rules.${index}.productId` as any
              );
              const selectedProduct = products?.find((p) => {
                return p.id === selectedProductId;
              });

              const optionsWithoutSelectedProduct = (products || []).filter(
                (x) => {
                  return (getValues("rules") || []).every((field: Rule) => {
                    return field.productId !== x.id;
                  });
                }
              );

              const options = [
                ...optionsWithoutSelectedProduct,
                ...(selectedProduct ? [selectedProduct] : []),
              ];

              return options;
            }}
          />
        </FormRow>
      </div>
    </div>
  );
};
